import React, { useEffect, useState } from 'react';
import api, { unwrap } from '../utils/api';

// Generic CRUD table for halls/shuls/peopleNames/autofillableFields/tags.
export default function SimpleCrud({ title, basePath, fields }) {
  const [items, setItems] = useState([]);
  const [draft, setDraft] = useState({});

  async function load() {
    const r = await api.get(`/miscellaneous/${basePath}`);
    setItems(unwrap(r) || []);
  }
  useEffect(() => { load(); }, [basePath]);

  async function create() {
    await api.post(`/miscellaneous/${basePath}`, draft);
    setDraft({});
    load();
  }
  async function remove(_id) {
    await api.post(`/miscellaneous/${basePath}/delete`, { _id });
    load();
  }

  return (
    <>
      <h1>{title}</h1>
      <div className="card">
        <div className="row">
          {fields.map(f => (
            <input key={f.key} placeholder={f.label} value={draft[f.key] || ''} onChange={e => setDraft(d => ({ ...d, [f.key]: e.target.value }))} />
          ))}
          <button className="btn" onClick={create}>Add</button>
        </div>
      </div>
      <div className="card">
        <table className="table">
          <thead><tr>{fields.map(f => <th key={f.key}>{f.label}</th>)}<th></th></tr></thead>
          <tbody>
            {items.map(i => (
              <tr key={i._id}>
                {fields.map(f => <td key={f.key}>{i[f.key]}</td>)}
                <td><button className="btn small danger" onClick={() => remove(i._id)}>Del</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
